import React from 'react';
import {WebView, WebViewNavigation} from 'react-native-webview';
import {Platform} from 'react-native';

import {useAppDispatch} from '../../../../redux';
import querystring from 'query-string';
import {useStyles} from '../../../../shared/hooks/styles';
import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';
import {addNotification} from '../../../../redux/actions/snackbar';
import {dobroruActions} from '../../../../redux/reducers/dobroru';
import Screen from '../../../../shared/components/screen';
import {loginDobroru} from '../../../../redux/actions/dobroru';
import {checkEsiaRedirectUrl} from '../../../../shared/utils/checkEsiaRedirectUrl';

export const DobroWebView = ({link}: {link: string}) => {
  const styles = useStyles(({theme}) => ({
    root: {
      paddingBottom: 40,
      backgroundColor: theme.color.backgroundMenuColor,
    },
    webView: {flex: 1},
  }));
  const dispatch = useAppDispatch();
  const isOldAndroid = Platform.OS === 'android' && typeof Platform.Version === 'number' && Platform.Version < 29;

  const onNavigationStateChange = ({url}: WebViewNavigation) => {
    if (!url) return;

    const isRedirectToOurDomain = checkEsiaRedirectUrl(url);
    if (!isRedirectToOurDomain) return;

    const [, params = ''] = url.split('?');
    const {code} = querystring.parse(params);

    dispatch(dobroruActions.setLink(null));
    if (code && typeof code === 'string') {
      dispatch(loginDobroru(code));
    } else {
      dispatch(
        addNotification({
          message: 'Не удалось получить код авторизации на портале добро.ру',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };

  return (
    <Screen style={styles.root}>
      <WebView
        scalesPageToFit
        startInLoadingState
        androidHardwareAccelerationDisabled
        androidLayerType={isOldAndroid ? 'software' : undefined}
        thirdPartyCookiesEnabled
        cacheEnabled={false}
        mixedContentMode='compatibility'
        source={{uri: link ?? ''}}
        containerStyle={styles.webView}
        onNavigationStateChange={onNavigationStateChange}
      />
    </Screen>
  );
};
